import type { IconBaseProps } from "./Icon";

export default function CrossIcon({ className, color, width, height }: IconBaseProps) {
  return (
    <svg
      className={className}
      style={{ color: color }}
      width={width ?? 19}
      height={height ?? 19}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Cross</title>
      <path
        d="M5.95371 13.6713L9.55371 10.0713L13.1537 13.6713L13.8617 12.9633L10.2617 9.36328L13.8617 5.76328L13.1537 5.05528L9.55371 8.65528L5.95371 5.05528L5.24571 5.76328L8.84571 9.36328L5.24571 12.9633L5.95371 13.6713ZM9.55671 18.3633C8.31271 18.3633 7.14271 18.1273 6.04671 17.6553C4.95138 17.1826 3.99838 16.5413 3.18771 15.7313C2.37704 14.9213 1.73538 13.9693 1.26271 12.8753C0.790044 11.7813 0.553711 10.6116 0.553711 9.36628C0.553711 8.12095 0.790044 6.95095 1.26271 5.85628C1.73471 4.76095 2.37504 3.80795 3.18371 2.99728C3.99238 2.18661 4.94471 1.54495 6.04071 1.07228C7.13671 0.599615 8.30671 0.363281 9.55071 0.363281C10.7947 0.363281 11.9647 0.599615 13.0607 1.07228C14.156 1.54428 15.109 2.18495 15.9197 2.99428C16.7304 3.80361 17.372 4.75595 17.8447 5.85128C18.3174 6.94661 18.5537 8.11628 18.5537 9.36028C18.5537 10.6043 18.3177 11.7743 17.8457 12.8703C17.3737 13.9663 16.7324 14.9193 15.9217 15.7293C15.111 16.5393 14.159 17.1809 13.0657 17.6543C11.9724 18.1276 10.8027 18.3639 9.55671 18.3633Z"
        fill="currentColor"
      />
    </svg>
  );
}
